<div>
  <small class="feedback-warning">{{feedback.warning}}</small>
  <ul class="feedback">
    <li *ngFor="let suggestion of feedback.suggestions" class="feedback-suggestion">
      {{suggestion}}
    </li>
  </ul>
</div>